
export default {
  name: 'ListingSukukBonds',
  fetchOnServer: false,

  data() {
    return {
      benefits: this.$t('benefits.blocks'),
    }
  },
}
